// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    SetPaymentDetailsState,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetPaymentDetailsState";
import { xGoogleAnalyticsState } from "@tps/App/GoogleAnalyticsConnector/Store/Reducers";

export const XngGaTrackAddPayment: typeof SetPaymentDetailsState = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const cart = getCurrentCartState(state);

    if (state.xGoogleAnalytics.checkoutFlowEvents && cart.value && !cart.isLoading) {
        (window as any)._GaCheckoutFunnel(
            3,
            cart.value,
            state.context?.session?.currency?.currencyCode,
            state.context?.session?.billToId,
            state.xGoogleAnalytics.includeProductBrand,
            state.xGoogleAnalytics.includeProductCategory,
            // TPS Customization
            state.context?.session,
        );
    }
};

addToEndOfChain(chain, XngGaTrackAddPayment);
